module.exports = __webpack_public_path__ + "static/media/logo-all-of-us-on.a4f16ae5.svg";